import { doAjax } from './helper'
import { getInteriorImageForStoredComponent} from './imagesLogicController'
import { saveStateWithAjax, getPackageImageSource, checkKey, checkSubmit } from './screen-package-selection-global'




function checkSeatsAndSteeringWheelBadges_a6limousine() {
	const imgSource = 'img/01_interieur/paketauswahl/au513_e-tron_gt_paketauswahl_rs_badges_zierleiste.png'
}

function addListeners_a6limousine(frontCheckboxesMap, modalsCheckboxesMap) {
	frontCheckboxesMap['YZ1'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YZ1',this.checked)
		
		if (document.querySelector("input[name=modelcategory]").value != 'a6') {
			if (this.checked) {
				const boxesToUncheck = ['3NT']
				boxesToUncheck.forEach(key => {
					frontCheckboxesMap[key].parentElement.classList.remove('is-checked')
					frontCheckboxesMap[key].checked = false
					saveStateWithAjax(key, false)
					getPackageImages_a6limousine(key, frontCheckboxesMap)
				});

				/* Clean popup checkboxes */
				jQuery("#three_nt_popup_yes").removeClass("is-checked");
				jQuery("#three_nt_popup_no").removeClass("is-checked");
				jQuery("#three_nt_popup_yes .aui-checkbox__input").prop("disabled", false);
				jQuery("#three_nt_popup_no .aui-checkbox__input").prop("disabled", false);
				jQuery("#submit_button").prop("disabled", true);
				
				/* Clean popup checkboxes */
		
			} else {		
				frontCheckboxesMap['3NT'].parentElement.classList.remove('is-checked')
				frontCheckboxesMap['3NT'].checked = false
				checkLocks_a6limousine(frontCheckboxesMap)
			}
		} else {
			checkLocks_a6limousine(frontCheckboxesMap)
		}		
		//CheckModalVisibility
		var CarmodelPopUp = document.querySelector("input[name='carmodel']").value
		if ((CarmodelPopUp == 11) || (CarmodelPopUp == 12) || (CarmodelPopUp == 13) || (CarmodelPopUp == 14))  {
			const modal = document.querySelectorAll('.modal')[0]
			if (this.checked) {
				modal.classList.remove("hidden");
			} else {
				modal.classList.add("hidden")
			}
		}
		getPackageImages_a6limousine('YZ1', frontCheckboxesMap)
	})

	frontCheckboxesMap['YQN'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YQN', this.checked)
		checkLocks_a6limousine(frontCheckboxesMap)
		getPackageImages_a6limousine('YQN', frontCheckboxesMap)
	})
	
	frontCheckboxesMap['YSJ_A6'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YSJ_A6', this.checked)
		checkLocks_a6limousine(frontCheckboxesMap)
		getPackageImages_a6limousine('YSJ_A6', frontCheckboxesMap)
	})

	frontCheckboxesMap['YVU'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YVU', this.checked);
		checkLocks_a6limousine(frontCheckboxesMap)
		getPackageImages_a6limousine('YVU', frontCheckboxesMap)
	})		
	
	frontCheckboxesMap['YUH'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YUH', this.checked);
		checkLocks_a6limousine(frontCheckboxesMap)
		getPackageImages_a6limousine('YUH', frontCheckboxesMap)
	})	
	
	frontCheckboxesMap['YTA'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YTA', this.checked);
		checkLocks_a6limousine(frontCheckboxesMap)
		getPackageImages_a6limousine('YTA', frontCheckboxesMap)
	})		
	
	frontCheckboxesMap['YTO'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YTO', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YTQ_A6'].checked == false) { 
				frontCheckboxesMap['YTQ_A6'].disabled = true
			}
		} else {
			checkLocks_a6limousine(frontCheckboxesMap)
		}
		getPackageImages_a6limousine('YTO', frontCheckboxesMap)
	})

	frontCheckboxesMap['YTQ_A6'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YTQ_A6', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YTO'].checked == false) { 
				frontCheckboxesMap['YTO'].disabled = true
			}
		} else {
			checkLocks_a6limousine(frontCheckboxesMap)
		}
		getPackageImages_a6limousine('YTQ_A6', frontCheckboxesMap)
	})	

	frontCheckboxesMap['YSR_A6'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YSR_A6', this.checked);
		checkLocks_a6limousine(frontCheckboxesMap)
		getPackageImages_a6limousine('YSR_A6', frontCheckboxesMap)
	})	

	/*
	frontCheckboxesMap['YVZ'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YVZ', this.checked);
		checkLocks_a6limousine(frontCheckboxesMap)
		//getImages_a6limousine('YVZ', frontCheckboxesMap)
		

		//CheckModalVisibility
		const modal = document.querySelectorAll('.modal')[0]
		if (this.checked) {
			modal.classList.remove("hidden")
		} else {
			modal.classList.add("hidden")
		}
		
	})
	*/

}

/**Controls frontcheckboxes disable */
function checkLocks_a6limousine(frontCheckboxesMap) {
	//DEFINE UNLOCK CONDITIONS
	//const unlockConditionForYSI = !frontCheckboxesMap['YSJ_A6'].checked
	//const unlockConditionForYSJ_A6 = !frontCheckboxesMap['YSI'].checked
	//const unlockConditionForYVU = !frontCheckboxesMap['YUH'].checked
	//const unlockConditionForYUH = !frontCheckboxesMap['YVU'].checked	
	const unlockConditionForYTO = !frontCheckboxesMap['YTQ_A6'].checked
	const unlockConditionForYTQ_A6 = !frontCheckboxesMap['YTO'].checked
	//const unlockConditionForYSR_A6 = !frontCheckboxesMap['YSQ'].checked
	//const unlockConditionForYSQ = !frontCheckboxesMap['YSR_A6'].checked
	//const unlockConditionForYVZ = true

	
	//UPDATE VARS 
	//frontCheckboxesMap['YSI'].disabled = !unlockConditionForYSI
	//frontCheckboxesMap['YSJ_A6'].disabled = !unlockConditionForYSJ_A6
	//frontCheckboxesMap['YVU'].disabled = !unlockConditionForYVU
	//frontCheckboxesMap['YUH'].disabled = !unlockConditionForYUH
	
	frontCheckboxesMap['YTO'].disabled = !unlockConditionForYTO
	frontCheckboxesMap['YTQ_A6'].disabled = !unlockConditionForYTQ_A6
	//frontCheckboxesMap['YSR_A6'].disabled = !unlockConditionForYSR_A6
	//frontCheckboxesMap['YSQ'].disabled = !unlockConditionForYSQ
	//frontCheckboxesMap['YVZ'].disabled = !unlockConditionForYVZ
}


/**Gets images for all packages depending on selected packages */

function getImages_a6limousine(frontCheckboxesMap) {
	for (const checkboxKey in frontCheckboxesMap) {
		//When screen loading
		/*
		const YRB_WAS_MODAL_SELECTED = frontCheckboxesMap['YVJ'].checked && frontCheckboxesMap['YSI'].checked
		const YVN_WAS_MODAL_SELECTED = frontCheckboxesMap['YVJ'].checked && frontCheckboxesMap['YSJ_A6'].checked
		*/
		/*
		if (YRB_WAS_MODAL_SELECTED || YVN_WAS_MODAL_SELECTED) {
			getPackageImages_a6limousine(YRB_WAS_MODAL_SELECTED ? 'YSI-YVJ' : 'YSJ_A6-YVJ', frontCheckboxesMap)
		}else{
			getPackageImages_a6limousine(checkboxKey, frontCheckboxesMap)
		}*/
		getPackageImages_a6limousine(checkboxKey, frontCheckboxesMap)
	}
}

function getPackageImages_a6limousine(packageCode, checkboxesMap) {
	let specialPackage = '';
	//When in modal
	if (packageCode == 'YSI-YVJ' || packageCode == 'YSJ_A6-YVJ'){
		specialPackage = packageCode
		packageCode = packageCode == 'YSI-YVJ' ? 'YSI' : 'YSJ_A6'
	}

	const checkboxElement = checkboxesMap[packageCode]
	const imageSource = specialPackage != '' ? getPackageImageSource(specialPackage) : getPackageImageSource(packageCode)
	let pressedPackageImg = document.getElementById(specialPackage != ''? specialPackage + '-img' : packageCode + '-img')
	const isChecked = checkboxElement.checked || checkboxElement.parentElement.classList.contains('is-checked')
	//if image does not exist we create it
	if (pressedPackageImg == null) {
		if (!isChecked ) return
		let imageArray = document.querySelector('.image-wrap')
		let newImage = document.createElement('IMG')
		newImage.classList.add('overlay')
		newImage.src = imageSource
		newImage.id = specialPackage != '' ? specialPackage + '-img' : packageCode + '-img'
		imageArray.insertAdjacentElement('beforeend', newImage)
	} else {
		pressedPackageImg.hidden = !isChecked
	}
	//change the steering wheel 
	//let hourMarkSteeringWheel = document.querySelector('#steering-wheel-overlay')
	//hourMarkSteeringWheel.src = checkboxesMap['YSJ_A6'].checked ? 'img/01_interieur/yrb-yvn_lenkrad/12-uhr-lenkrad_yvn_1xw-2pf/basislayer_alacantara_schwarz/au513_e-tron_gt_interior_lenkrad_yvn_1xw-2pf_basislayer.png' : ""
}


export { addListeners_a6limousine, saveStateWithAjax, checkLocks_a6limousine, getImages_a6limousine, getPackageImages_a6limousine, checkSeatsAndSteeringWheelBadges_a6limousine}

